// extracted by mini-css-extract-plugin
export default {"full_size":"Report_full_size__MAfLT","loading":"Report_loading__ylu+Z","search":"Report_search__zU+nc"};